import { createAction, props } from '@ngrx/store'
import {
  CopilotConversation,
  CopilotConversationDetail,
  CopilotConversationListItem,
  CopilotMessage,
  CopilotResult,
} from '../analytics/copilot/models/copilot.model'

export const createConversation = createAction(
  '[Analytics Copilot] Create Conversation',
  props<{ userId: string; conversation: CopilotConversation }>()
)

export const appendMessage = createAction(
  '[Analytics Copilot] Append Message',
  props<{ userId: string; conversationId: string; message: CopilotMessage }>()
)

export const setConversationTitle = createAction(
  '[Analytics Copilot] Set Conversation Title',
  props<{ userId: string; conversationId: string; title: string }>()
)

export const updateLastAssistantMessage = createAction(
  '[Analytics Copilot] Update Last Assistant Message',
  props<{
    userId: string
    conversationId: string
    patch: Partial<CopilotMessage>
  }>()
)

export const togglePinned = createAction(
  '[Analytics Copilot] Toggle Pinned',
  props<{ userId: string; conversationId: string }>()
)

export const deleteConversation = createAction(
  '[Analytics Copilot] Delete Conversation',
  props<{ userId: string; conversationId: string }>()
)

export const discardDraftIfEmpty = createAction(
  '[Analytics Copilot] Discard Draft If Empty',
  props<{ userId: string; conversationId: string }>()
)

// Load actions (backend persistence)

export const loadConversations = createAction(
  '[Analytics Copilot] Load Conversations',
  props<{ userId: string }>()
)

export const loadConversationsSuccess = createAction(
  '[Analytics Copilot] Load Conversations Success',
  props<{ userId: string; conversations: CopilotConversationListItem[] }>()
)

export const loadConversation = createAction(
  '[Analytics Copilot] Load Conversation',
  props<{ userId: string; id: string }>()
)

export const loadConversationSuccess = createAction(
  '[Analytics Copilot] Load Conversation Success',
  props<{ userId: string; conversation: CopilotConversationDetail }>()
)

export const loadConversationFailure = createAction(
  '[Analytics Copilot] Load Conversation Failure',
  props<{ id: string }>()
)

export const hydrateAssistantResult = createAction(
  '[Analytics Copilot] Hydrate Assistant Result',
  props<{
    userId: string
    conversationId: string
    messageId: string
    result: CopilotResult
  }>()
)
